import { Modal, useModals } from 'almanac-ui/Modal'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { MobileHeader } from 'screens/BrandKits/components/SourceMaterialModal/MobileHeader'
import Styles from 'screens/BrandKits/components/SourceMaterialModal/SourceMaterialModal.module.scss'
import ReactMarkdown from 'react-markdown'

interface Props {
  content: string
}

export const TranscriptionModal = ({ content }: Props) => {
  const { closeModal } = useModals()

  return (
    <Modal.Root size="lg" blaze onClose={closeModal} onPressOutside={closeModal} aria-label="Transcription">
      <ResponsiveDesign.Desktop>
        <Modal.Header title="Transcription" />
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <MobileHeader onBack={closeModal}>Transcription</MobileHeader>
      </ResponsiveDesign.Mobile>
      <Modal.Content>
        <ReactMarkdown className={Styles.transcription}>{content}</ReactMarkdown>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={closeModal}>
            Close
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
